import { useEffect } from 'react'
import {
  VStack,
  Box,
  Text,
  Switch,
  useColorMode,
  HStack,
  Icon,
  useMediaQuery,
  Container,
  Heading
} from '@chakra-ui/react'
import { SunIcon, MoonIcon } from '@chakra-ui/icons'

export const Preferences = () => {
  const { colorMode, setColorMode } = useColorMode()
  const [isSystemDark] = useMediaQuery('(prefers-color-scheme: dark)')

  // Align with system theme on first load
  useEffect(() => {
    const systemTheme = isSystemDark ? 'dark' : 'light'
    const savedTheme = localStorage.getItem('chakra-ui-color-mode')
    
    if (!savedTheme) {
      setColorMode(systemTheme)
    }
  }, [isSystemDark, setColorMode])

  const handleThemeChange = () => {
    setColorMode(colorMode === 'light' ? 'dark' : 'light')
  }

  return (
    <Container maxW="container.lg" py={8}>
      <Heading mb={6}>Preferences</Heading>
      
      <VStack spacing={8} align="start" width="100%">
        <Box width="100%" p={6} borderWidth="1px" borderRadius="lg">
          <Text fontSize="lg" fontWeight="bold" mb={4}>
            Appearance
          </Text>
          
          <HStack spacing={4}>
            <Icon as={SunIcon} />
            <Switch
              isChecked={colorMode === 'dark'}
              onChange={handleThemeChange}
              size="lg"
            />
            <Icon as={MoonIcon} />
            <Text ml={2}>
              {colorMode === 'light' ? 'Light' : 'Dark'} Mode
            </Text>
          </HStack>

          <Text fontSize="sm" color="gray.500" mt={2}>
            System preference: {isSystemDark ? 'Dark' : 'Light'}
          </Text>
        </Box>

        {/* Add more preference sections here */}
      </VStack>
    </Container>
  )
} 